import { createStore } from 'vuex';
import {
  RESET,
  SET_BILL,
  SET_NUMBER_OF_PEOPLE,
  SET_TIP_PERCENTAGE,
} from './mutations';

export interface State {
  bill: number;
  tipPercentage: number;
  numberOfPeople: number;
}

export default createStore<State>({
  state: {
    bill: 0,
    tipPercentage: 0,
    numberOfPeople: 0,
  },
  mutations: {
    [SET_BILL](state, payload: { value: number }) {
      state.bill = payload.value;
    },
    [SET_NUMBER_OF_PEOPLE](state, payload: { value: number }) {
      state.numberOfPeople = payload.value;
    },
    [SET_TIP_PERCENTAGE](state, payload: { value: number }) {
      state.tipPercentage = payload.value / 100;
    },
    [RESET](state) {
      state.bill = 0;
      state.numberOfPeople = 0;
      state.tipPercentage = 0;
    },
  },
  getters: {
    tipAmount(state) {
      const result = (state.bill * state.tipPercentage) / state.numberOfPeople;
      if (!isNaN(result) && isFinite(result)) return result;
      return 0;
    },
    totalPay(state) {
      const result = (state.bill + (state.bill * state.tipPercentage)) / 5;
      if (!isNaN(result)) return result;
      return 0;
    },
    isStateEmpty(state) {
      return (
        state.bill === 0 &&
        state.numberOfPeople === 0 &&
        state.tipPercentage === 0
      );
    },
  },
});
